import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

const Experience = ({ sectionName, experience }) => {
    const Companies = experience.map((company, i) => {
        const techs = company.technologies.map((technology, idx) => {
            return (
                <span className="badge rounded-pill text-black experience-badge mx-2 mb-2" key={idx}>
                    {technology}
                </span>
            );
        });

        const mainTechs = company.mainTech.map((technology, idx) => {
            return (
                <span className="badge rounded-pill text-white main-badge mx-2 mb-2" key={idx}>
                    {technology}
                </span>
            );
        });
        return (
            <VerticalTimelineElement
                className="vertical-timeline-element"
                date={company.years}
                dateClassName="text-black fs-5"
                iconStyle={{
                    background: '#635bff',
                    color: '#fff',
                    textAlign: 'center'
                }}
                icon={<i className={company.icon}></i>}
                key={i}
            >
                <div style={{ textAlign: 'left', marginBottom: '4px' }}>{mainTechs}</div>

                <h3 className="vertical-timeline-element-title" style={{ textAlign: 'left' }}>
                    {company.title}
                </h3>

                <h4 className="vertical-timeline-element-subtitle" style={{ textAlign: 'left' }}>
                    {company.company}
                </h4>

                <p className="modal-description text-justified" style={{ fontSize: '120%' }}>
                    {company.description}
                </p>

                <div style={{ textAlign: 'left', marginTop: '15px' }}>{techs}</div>
            </VerticalTimelineElement>
        );
    });

    return (
        <section id="resume" className="pb-5">
            <div className="col-md-12 mx-auto">
                <div className="col-md-12">
                    <h1 className="section-title" style={{ color: 'black' }}>
                        <span className="text-black" style={{ textAlign: 'center' }}>
                            {sectionName}
                        </span>
                    </h1>
                </div>
            </div>
            <div className="col-md-8 mx-auto">
                <VerticalTimeline animate={true}>
                    {Companies}
                    <VerticalTimelineElement
                        iconStyle={{
                            background: '#635bff',
                            color: '#fff',
                            textAlign: 'center'
                        }}
                        icon={<i className="fas fa-hourglass-start mx-auto experience-icon"></i>}
                    />
                </VerticalTimeline>
            </div>
        </section>
    );
};

export default Experience;
